import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textEllipsisFn = /* @__PURE__ */ createRecipe('text-ellipsis', {}, [])

const textEllipsisVariantMap = {}

const textEllipsisVariantKeys = Object.keys(textEllipsisVariantMap)

export const textEllipsis = /* @__PURE__ */ Object.assign(memo(textEllipsisFn.recipeFn), {
  __recipe__: true,
  __name__: 'textEllipsis',
  __getCompoundVariantCss__: textEllipsisFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textEllipsisVariantKeys,
  variantMap: textEllipsisVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textEllipsisVariantKeys)
  },
  getVariantProps: textEllipsisFn.getVariantProps,
})